import React from 'react';

export default function ScreenShareIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3539 1.64645C22.5491 1.84171 22.5491 2.15829 22.3539 2.35355L9.74515 14.9622C9.54989 15.1575 9.23331 15.1575 9.03805 14.9622C8.84279 14.767 8.84279 14.4504 9.03805 14.2551L21.6467 1.64645C21.842 1.45118 22.1586 1.45118 22.3539 1.64645Z"
        fill="#D8D8D8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3536 1.64646C22.4988 1.79171 22.5404 2.011 22.4585 2.19938L13.7629 22.1994C13.6863 22.3756 13.5155 22.4923 13.3235 22.4996C13.1316 22.507 12.9523 22.4037 12.8625 22.234L9.02139 14.9786L1.76606 11.1376C1.59627 11.0477 1.493 10.8685 1.50037 10.6765C1.50774 10.4845 1.62446 10.3137 1.80064 10.2371L21.8006 1.54148C21.989 1.45958 22.2083 1.50122 22.3536 1.64646ZM3.15222 10.7399L9.62525 14.1668C9.71385 14.2137 9.7863 14.2862 9.8332 14.3748L13.2601 20.8478L21.0354 2.96463L3.15222 10.7399Z"
        fill="#D8D8D8"
      />
    </svg>
  );
}
